module.exports = __webpack_public_path__ + "img/h.0300f3ab.png";